import store from "../redux/store";

/**
 * Filters promotion data based on customer category eligibility
 * Automatically gets customer category from Redux store
 * @param {Object|Array} data - Single product object or array of products
 * @returns {Object|Array} - Filtered product(s) with promotion fields removed if not eligible
 */
export function filterPromotionsByCustomerId(data) {
  // Get customer category from Redux store
  const state = store.getState();
  const customerId = state?.user?.info?.category;

  // Handle single product object
  if (!Array.isArray(data)) {
    return filterSingleProduct(data, customerId);
  }

  // Handle array of products
  return data.map((product) => filterSingleProduct(product, customerId));
}

/**
 * Filters promotion data for a single product
 * @param {Object} product - Product object
 * @param {string|number} customerId - Customer category ID
 * @returns {Object} - Filtered product with promotion fields removed if not eligible
 */
function filterSingleProduct(product, customerId) {
  if (!product) return product;

  // If no customercategory restriction, promotion applies to everyone
  if (!product.customercategory) {
    return product;
  }

  // If has category restriction but no customerId, remove promotions
  if (!customerId) {
    return removePromotionFields(product);
  }

  // Check if customerId matches allowed categories
  const allowedCategories = String(product.customercategory)
    .split(",")
    .map((cat) => cat.trim());

  const categoryMatches = allowedCategories.some(
    (allowedCat) =>
      String(customerId) === allowedCat ||
      Number(customerId) === Number(allowedCat)
  );

  // If category doesn't match, remove promotion fields
  if (!categoryMatches) {
    return removePromotionFields(product);
  }

  // Category matches - return product as-is
  return product;
}

/**
 * Removes promotion-related fields from a product
 * @param {Object} product - Product object
 * @returns {Object} - Product with promotion fields set to null
 */
function removePromotionFields(product) {
  return {
    ...product,
    fixedprice: null,
    itemquantifier: null,
    promotion_code: null,
    promotioncode_id: null,
    promotion_name: null,
    stockdescription: null,
  };
}
